<template>
  <div class="m-r-4 m-l-4">
    <Popover
      overlayClassName="pop"
      :visible="reportStore.showReport"
      :overlayStyle="{ width: '600px' }"
      trigger="click"
      :on-visible-change="handleShowReport"
    >
      <template #title>
        <div class="report-tips">
          *报表文件生成后将在系统保留3天，过期将自动删除
        </div>
      </template>
      <template #content>
        <ReportDownload />
      </template>
      <i
        style="font-size: 18px"
        class="iconfont icon-caozuojilu text-secondary"
      ></i>
    </Popover>
  </div>
</template>

<script setup lang="ts">
import { Popover } from 'ant-design-vue';
import { useReportStore } from '/@/store/modules/reportDownload';
import ReportDownload from './components/reportDownload.vue';
const reportStore = useReportStore();

const handleShowReport = () => {
  reportStore.setShowReport(!reportStore.showReport);
  console.log('reportStore.showReport', reportStore.showReport);
};
</script>

<style scoped></style>
